// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__rt8Cy","searchForm":"Search_searchForm__UhEUL","searchBtn":"Search_searchBtn__7XLrs","searchIcon":"Search_searchIcon__fa2oq"};